import React, { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import '../../../../../../styles/global.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Link } from '../../../../../UI/Elements/Link';
import {
  DiopterPicker,
  DiopterPickerProps,
} from '../../../../../UI/Cards/Shop/DiopterPicker/index';
import {
  productWithLiveShopifyState,
  variantState,
} from '../../../../../../utils/recoil/product';
import { withSuspense } from '../../../../../../utils/hocs/withSuspense';
import { updateUrlParams } from 'utils/globals';

const LoadingProductMainDiopterPicker: React.FC<DiopterPickerProps> = () => (
  <div className='flex'>
    {['', '', '', '', ''].map(() => (
      <div className='bg-gray-200 mb-4 rounded-full mr-2 animate-pulse w-12 h-7' />
    ))}
  </div>
);

const PureProductMainDiopterPicker: React.FC<DiopterPickerProps> = withSuspense(
  ({ category, variant }) => {
    const setVariant = useSetRecoilState(variantState);
    const shopifyProductState = useRecoilValue(productWithLiveShopifyState);

    const shopifyDiopters = shopifyProductState?.variants.filter((v) => {
      if (variant.color) {
        return (
          v.selectedOptions?.color?.toLowerCase() ===
          variant.color.shopifyKey?.toLowerCase()
        );
      }
    });

    return (
      <DiopterPicker
        onDiopterChange={(diopter) => {
          updateUrlParams('diopter', diopter);
          setVariant({
            ...variant,
            diopter,
          });
        }}
        variant={variant}
        variants={shopifyDiopters}
        color={category?.color}
      />
    );
  },
  <LoadingProductMainDiopterPicker />
);

export const ProductMainDiopterPicker = ({
  label,
  subLabel,
  link,
  variant,
  category,
}) => (
  <div className='w-full'>
    <div className='flex w-full items-center justify-between my-3'>
      <Label
        weight='bold'
        color={{ classname: 'gray-700' }}
        text={label?.text}
      />
      <Link
        {...link}
        label={{
          ...link.label,
          decoration: 'underline',
          size: 'sm',
          weight: 'base',
        }}
      />
    </div>
    <div className='flex flex-wrap'>
      <PureProductMainDiopterPicker
        variant={variant}
        category={category}
      />
    </div>
    {subLabel && (
      <div className='mt-1 mb-3'>
        <Label
          {...subLabel}
          family='font-inter'
          color={{ classname: 'gray-600' }}
          size='sm'
        />
      </div>
    )}
  </div>
);
